import * as actionTypes from "./ActionTypes";
import {
  postRequest,
  getRequest,
  putRequest,
  postRequestFile,
  postRequestVerify,
  loginRequest,
  postResetPass,
} from "../Helper/ApiHit";

//--------------------API LOGIN PAGE DEEPAK -------------------------------------------------------------
// export const getLogin = (email, password, candidateUserType) => {
//   return (dispatch) => {
//     dispatch({ type: actionTypes.LOGIN_INITIAL });
//     loginRequest("employer/signin", {
//       email: `cn${email}`,
//       password: password,
//       candidateUserType: candidateUserType,
//     })
//       .then((res) => {
//         if (res.data.responseStatus.statusCode === 0) {
//           localStorage.setItem("userToken", res.headers.authorization);
//           localStorage.setItem(
//             "userType",
//             res?.data?.responseData?.candidateUserType
//           );
//           // if(email.split('').shift() === 'i'){
//           //     getRequest(`interviewer/getInterviewerLoginCount`)
//           //     .then(res => {
//           //         if(res.data.responseStatus.statusCode === 0){
//           //              console.log(res)
//           //         }
//           //     })
//           // }

//           const userData = res.data.responseData;
//           return dispatch({
//             type: actionTypes.LOGIN_SUCCESS,
//             payload: true,
//             candidateUserType: userData.candidateUserType,
//           });
//         } else {
//           return dispatch({
//             type: actionTypes.LOGIN_FAIL,
//             payload: res.data.responseData.message,
//             ErrorCode: res.data.responseData.errorCode,
//           });
//         }
//       })
//       .catch((error) => {
//         localStorage.setItem("user", "");
//         return dispatch({
//           type: actionTypes.LOGIN_FAIL,
//           payload: "Server Error,Try Again",
//         });
//       });
//   };
// };
export const getLogin = (email, password, candidateUserType) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.LOGIN_INITIAL });
    loginRequest("employer/signin", {
      email: `cn${email}`,
      password: password,
      candidateUserType: candidateUserType,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          localStorage.setItem("userToken", res.headers.authorization);
          localStorage.setItem(
            "userType",
            res?.data?.responseData?.candidateUserType
          );
          localStorage.setItem(
            "candidateId",
            res?.data?.responseData?.candidateUserType
          );
          localStorage.setItem(
            "jobProfileId",
            res?.data?.responseData?.candidateUserType
          );
          localStorage.setItem("companyId", res?.data?.responseData?.companyId);
          dispatch({
            type: actionTypes.LOGIN_SUCCESS,
            payload: true,
            candidateUserType: res.data.responseData.candidateUserType,
          });

          return getRequest(`candidate/candidateDetails`);
        } else {
          dispatch({
            type: actionTypes.LOGIN_FAIL,
            payload: res.data.responseData.message,
            ErrorCode: res.data.responseData.errorCode,
          });

          return Promise.reject("Employer sign-in failed");
        }
      })
      .then((candidateRes) => {
        dispatch({
          type: actionTypes.CANDIDATE_SUCCESS,
          ManageRecords: candidateRes.data.responseData,
        });
        localStorage.setItem(
          "candidateId",
          candidateRes.data.responseData.candidateId
        );
        localStorage.setItem(
          "jobProfileId",
          candidateRes.data.responseData.jobProfileId
        );
      })

      .catch((error) => {
        localStorage.setItem("user", "");
        dispatch({
          type: actionTypes.CANDIDATE_FAIL,
          messageError: error.message || "Server Error, Try Again",
        });
      });
  };
};

//--------------------API VERIFYINTERVIWEREMAIL PAGE DEEPAK -------------------------------------------------------------
export const verifyInterviewerEmail = (token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.VERIFY_EMAIL_INITIAL });
    getRequest(`interviewer/verifyInterviewerEmail?token=${token}`)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.VERIFY_EMAIL_SUCCESS,
            payload: true,
          });
        } else {
          return dispatch({
            type: actionTypes.VERIFY_EMAIL_FAIL,
            payload: false,
            errorMsgVerifyEmail: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        //    console.log(error)
        return dispatch({
          type: actionTypes.VERIFY_EMAIL_NETWORK_ERROR,
        });
      });
  };
};

//--------------------API VERIFYINTERVIWEREMAIL PAGE DEEPAK -------------------------------------------------------------
export const verifyEmail = (token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.VERIFY_EMAIL_INITIAL });
    getRequest(`candidate/verifyEmail?token=${token}`)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.VERIFY_EMAIL_SUCCESS,
            payload: true,
          });
        } else {
          return dispatch({
            type: actionTypes.VERIFY_EMAIL_FAIL,
            payload: false,
            errorMsgVerifyEmail: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        //    console.log(error)
        return dispatch({
          type: actionTypes.VERIFY_EMAIL_NETWORK_ERROR,
        });
      });
  };
};

//--------------------API signUP PAGE NIKHIL -------------------------------------------------------------
export const getSignUp = (formData) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.SIGNUP_INITIAL });
    postRequest("candidate/signup", formData)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.SIGNUP_SUCCESS,
            payload: true,
          });
        } else {
          return dispatch({
            type: actionTypes.SIGNUP_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.SIGNUP_EXT_ERROR,
          payload: err.message,
        });
      });
  };
};

//--------------------API Resend SignUp Email NIKHIL -------------------------------------------------------------
export const resendSignUpEmail = (email) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.RESEND_SIGNUP_EMAIL_INITIAL });
    postRequest("candidate/resendVerificationEmail", {
      email: email,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.RESEND_SIGNUP_EMAIL_SUCCESS,
            payload: true,
          });
        } else {
          return dispatch({
            type: actionTypes.RESEND_SIGNUP_EMAIL_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.RESEND_SIGNUP_EMAIL_FAIL,
          payload: err.message,
        });
      });
  };
};

//--------------------API GET PASSWORD RESET LINK NIKHIL-------------------------------------------------------------------------

export const getForgotPasswordLink = (email, x) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.FORGOT_PASSWORD_LINK_INITIAL });
    postRequest("employer/generatePasswordResetToken", {
      email: email,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          if (x === 1) {
            return dispatch({
              type: actionTypes.FORGOT_PASSWORD_LINK_SUCCESS,
              email: email,
              resend: false,
            });
          } else {
            return dispatch({
              type: actionTypes.FORGOT_PASSWORD_LINK_SUCCESS,
              email: email,
              resend: true,
            });
          }
        } else {
          return dispatch({
            type: actionTypes.FORGOT_PASSWORD_LINK_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.FORGOT_PASSWORD_NETWORK_ERROR,
        });
      });
  };
};

//--------------------Hide Second Screen coming on click of Forgot Password - Nikhil-------------------------------------------------------------------------
export const changeResetLinkState = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FORGOT_PASSWORD_SECOND_SCREEN_HIDE,
    });
  };
};

//--------------------API reset password BRIJESH-------------------------------------------------------------------------
export const getResetPassword = (email, pass, token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.RESET_PASSWORD_INITIAL });
    postResetPass(
      "employer/resetPassword",
      {
        emailId: email,
        password: pass,
      },
      token
    )
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.RESET_PASSWORD_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.RESET_PASSWORD_FAIL,
            payload: res.data.responseData,
          });
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  };
};

export const logedinresetEployer = (current, newpass, confirm) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.EMPLOYER_LOGED_RESET_PASSWORD_INITIAL });
    postRequest("candidate/resetPassword", {
      confirmPassword: confirm,
      newPassword: newpass,
      oldPassword: current,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.EMPLOYER_LOGED_RESET_PASSWORD_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.EMPLOYER_LOGED_RESET_PASSWORD_FAIL,
            payload: res.data.responseData,
          });
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  };
};

export const updatedMobileVerification = (mobile) => {
  return (dispatch) => {
    console.log("cjeck2");
    dispatch({ type: actionTypes.UPDATED_MOBILE_INITIAL });
    postRequest("candidate/sendUpdatedMobileOTP", {
      mobileNo: mobile,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.UPDATED_MOBILE_SUCCESS,
          });
        } else {
          console.log("cjeck1");
          return dispatch({
            type: actionTypes.UPDATED_MOBILE_FAIL,
            payload: res.data.responseData,
          });
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  };
};

export const updatedOtpVerification = (otp) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.UPDATED_OTP_INITIAL });
    postRequest("candidate/verifyUpdatedMobileOTP", {
      otp: otp,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.UPDATED_OTP_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.UPDATED_OTP_FAIL,
            payload: res.data.responseData,
          });
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  };
};

export const updatedNameVerification = (name) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.UPDATED_NAME_INITIAL });
    postRequest("candidate/updateCandidateProfile", {
      name: name,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.UPDATED_NAME_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.UPDATED_NAME_FAIL,
            payload: res.data.responseData,
          });
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  };
};

export const resetStateVerifyState = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_VERIFY_STATE,
    });
  };
};

export const resetSignupSate = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_SIGNUP_STATE,
    });
  };
};

export const resetOtpUpdated = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_VERIFY_STATE,
    });
  };
};

export const resetlast = () => {
  return (dispatch) => {
    dispatch({
      type: "OTP_UPDATED_RESET",
    });
  };
};
